import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs } from '../data/offer';
import { purchases } from '../data/testimonials';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="3bt44hxwhrzod">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3brj4vtvblqjn">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="3gkceav1qhn22" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="31vg6mz3lac1z">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="36uj15ply0zvp">
            <p className="text-slate-300" data-id="element-26" data-mp="2svjcihyfkkzj">Abrís los volúmenes. Aplicás el protocolo.</p>
            <p className="mt-4 text-slate-300" data-id="element-27" data-mp="2ww3cdtae22pd">
              Si después de probar el material considerás que no es para vos, podés
              solicitar la devolución dentro de los 14 días.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28" data-mp="2arp2cqgn93rv">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="2pnn18ghycm7s">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30" data-mp="2kp210h2pa2jc">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>
      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31" data-mp="1s30jsb5mvaj9">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="1s0edeeuhb12m">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="26s6oufr5juz2">
            ❓ PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="21z3qzvfcdzd2">
            {faqs.map(({
            question,
            answer
          }, index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35" data-mp="19b80x9ka35p9" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36" data-mp="230yqzlrhaoa2">
                    <span data-id="element-37" data-mp="1g3dm4plyv6ga">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="1k1ukokrbn8m3" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="30h4dm6i5xg94">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-40" data-mp="35fp6tlyzyzo2">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41" data-mp="k0zh8q18crzb">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42" data-mp="160x7atz1ut8">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="3sbaqpch6cr7l">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44" data-mp="3sclu3b6pjwy6">
          ⚖️ ¿CUÁNTO CUESTA NO TENER ESTE PROTOCOLO?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45" data-mp="1qk5zghj5lsns">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="1ykbzd3qcnk2h">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47" data-mp="1okuweu2hfka7">
                ×
              </span>
              {item}
            </p>)}
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-48" data-mp="wwktfzqsc78b">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-49" data-mp="10xwmkf8vbal9">
          🎯 PROTOCOLO REENCUENTRO EN CALMA™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-50" data-mp="darhmyebbg7d">
          El sistema de comunicación post-conflicto para mujeres argentinas que cuidan a
          un familiar con Párkinson.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-51" data-mp="11640r6572czc">
          “No es solo saber hablar. Es volver a acercarse sin miedo.”
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-52" data-mp="w70ujidha0ps">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-53" data-mp="19xw7b5r3l1yn">
            📧 soportebiomalivido@gmail.com
          </a>
          <span data-id="element-54" data-mp="1jwc1jhlf8rcd">📲 @biomalivido</span>
          <a className="hover:text-brand-light" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-55" data-mp="1jxdangivn3rg">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-56" data-mp="cijex6sb70z9">
          © PROTOCOLO REENCUENTRO EN CALMA™ 2026 — Todos los derechos reservados.
        </p>
      </footer>
      <AnimatePresence data-id="element-57" data-mp="lk9569agftvg">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-58" data-mp="qbr6iyge3wgy">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-59" data-mp="19amw1whazmog">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="363f0cl03x8vj" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-61" data-mp="3b31cer478j2r">
              {purchases[purchase].name} de {purchases[purchase].place}
            </p>
            <p className="text-sm text-slate-300" data-id="element-62" data-mp="33kjxu6hgue2x">
              compró el Protocolo Reencuentro en Calma™
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-63" data-mp="2tse9r7uc4gt0">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}